import '../css/app.css'
import CookiesEuBanner from "cookies-eu-banner";

// responsive main nav
(function () {

  function initNav(navEl, toggleEl) {

    const labelEl = toggleEl.querySelector('span');

    toggleEl.addEventListener('click', () => {
      if(!isOpen()) {
        open();
      } else {
        close();
      }
    });

    document.addEventListener('keydown', e => {

      if (!isOpen()) {
        return;
      }

      if (e.key === 'Escape') {
        close();
      }

    });

    function open() {
      navEl.style.display = 'block';
      toggleEl.setAttribute('aria-expanded', true);
      labelEl.innerText = 'sluit';
    }

    function close() {
      navEl.style.display = 'none';
      toggleEl.setAttribute('aria-expanded', false);
      toggleEl.focus();
      labelEl.innerText = 'menu';
    }

    function isOpen() {
      return navEl.style.display !== 'none';
    }

  }

  const smallNavEl = document.querySelector('.small-only .header-nav');
  const smallToggleEl = document.querySelector('.small-only .navigation__toggle');
  initNav(smallNavEl, smallToggleEl);

})();

// responsive facets
(function () {

  const sidebarEl = document.querySelector('.view__sidebar');
  if (!sidebarEl) {
    return;
  }
  const toggleEl = document.querySelector('.view__sidebar__toggle');
  if (!toggleEl) {
    return;
  }
  const labelEl = toggleEl.querySelector('span');
  const openLabelText = labelEl.innerText;
  const closeLabelText = labelEl.closest('[data-close-label]').dataset.closeLabel;

  toggleEl.addEventListener('click', () => {
    if(!isOpen()) {
      open();
    } else {
      close();
    }
  });

  document.addEventListener('keydown', e => {

    if (!isOpen()) {
      return;
    }

    if (e.key === 'Escape') {
      close();
    }

  });

  function open() {
    sidebarEl.style.display = 'block';
    toggleEl.setAttribute('aria-expanded', 'true');
    labelEl.innerText = closeLabelText;
  }

  function close() {
    sidebarEl.style.display = 'none';
    toggleEl.setAttribute('aria-expanded', 'false');
    toggleEl.focus();
    labelEl.innerText = openLabelText;
  }

  function isOpen() {
    return window.getComputedStyle(sidebarEl).display !== 'none';
  }

})();

// prepend http:// in <input type="url"> if missing
(function () {

  document.addEventListener('change', e => {
    const el = e.target;
    if (el.tagName.toLowerCase() !== 'input') {
      return;
    }
    if (el.type !== 'url') {
      return;
    }
    if (!el.value) {
      return;
    }
    if (!el.value.startsWith('http://') && !el.value.startsWith('https://')) {
      el.value = 'http://' + el.value;
    }
  });

})();

// cookie banner
window.addEventListener('DOMContentLoaded', () => {

  // const bannerEl = document.getElementById('cookies-eu-banner');
  //
  // const focusableEls = bannerEl.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
  // const firstFocusableEl = focusableEls[0];
  // const lastFocusableEl = focusableEls[focusableEls.length - 1];
  // const KEYCODE_TAB = 9;
  //
  // bannerEl.addEventListener('keydown', function (e) {
  //
  //   const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
  //   if (!isTabPressed) {
  //     return;
  //   }
  //
  //   if (e.shiftKey) /* shift + tab */ {
  //     if (document.activeElement === firstFocusableEl) {
  //       lastFocusableEl.focus();
  //       e.preventDefault();
  //     }
  //   }
  //   else /* tab */ {
  //     if (document.activeElement === lastFocusableEl) {
  //       firstFocusableEl.focus();
  //       e.preventDefault();
  //     }
  //   }
  //
  // });

  new CookiesEuBanner(function () {
    const gtagId = 'G-9XDCDEP9YT';
    window.dataLayer = window.dataLayer || [];
    const firstScriptEl = document.getElementsByTagName('script')[0];
    const gtagScriptEl = document.createElement('script');
    gtagScriptEl.async = true;
    gtagScriptEl.src = 'https://www.googletagmanager.com/gtag/js?id=' + gtagId;
    firstScriptEl.parentNode.insertBefore(gtagScriptEl, firstScriptEl);
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', gtagId, { 'anonymize_ip': true });
  }, true);

});
